import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BoyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"boy"}/>
}
